import Dialog from "../../atoms/dialog";
import { useState } from 'react';
import DeleteBlueprintBackup from '../blueprint/DeleteBlueprintBackup'

export default function DeleteBackupAlert(props) {
    const { onCompletion, onClose, deletePayload } = props;

    const [open, setOpen] = useState(false);


    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            open={true}
            handleClose={onClose}
        >
            <DeleteBlueprintBackup id={"id"} onCompletion={onCompletion} onClose={handleClose} deletePayload={deletePayload} />

        </Dialog >
    )
}